<template>
  <div class="acceptance-detail-container animated fadeInRight">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>验收单详情</span>
        <el-button style="float: right; padding: 3px 0; margin-left: 10px;" type="text" @click="goBack">返回</el-button>
        <!-- <el-button style="float: right; padding: 3px 0" type="primary" @click="handlePreviewAcceptance">生成验收单</el-button> -->
      </div>

      <div v-loading="loading">
        <div v-if="detailData" class="repair-detail-content">
          <!-- 工单详情 -->
          <el-card class="detail-section" shadow="never">
            <div slot="header" class="section-title">工单详情</div>
            <el-descriptions :column="2" border>
              <el-descriptions-item label="工单号">{{ detailData.orderNo || '-' }}</el-descriptions-item>
              <el-descriptions-item label="报修类型">
                {{ getOrderTypeText(detailData.orderType) }}
              </el-descriptions-item>
              <el-descriptions-item label="报修部位">{{ detailData.itemName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="所属专业">{{ detailData.professionName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="报修人">
                {{ detailData.initiatorName }}({{ detailData.initiatorPhone }})
              </el-descriptions-item>
              <el-descriptions-item label="位置" :span="2">{{ getDetailLocationText() }}</el-descriptions-item>
              <el-descriptions-item label="创建时间">{{ detailData.createTime || '-' }}</el-descriptions-item>
              <el-descriptions-item label="预约时间">{{ detailData.bookingTime || '-' }}</el-descriptions-item>
              <el-descriptions-item label="完成时间" v-if="detailData.finishTime">{{ detailData.finishTime }}</el-descriptions-item>
              <el-descriptions-item label="保修期" v-if="detailData.warrantyType && detailData.warrantyType !== '0'">
                {{ getWarrantyTypeText(detailData.warrantyType) }}
              </el-descriptions-item>
              <el-descriptions-item label="报修内容" :span="2">{{ detailData.problemDesc || '-' }}</el-descriptions-item>
              <el-descriptions-item label="报修图片" :span="2" v-if="getImageList(detailData.problemImgs).length > 0">
                <div class="image-list">
                  <el-image
                    v-for="(img, index) in getImageList(detailData.problemImgs)"
                    :key="index"
                    :src="img"
                    :preview-src-list="getImageList(detailData.problemImgs)"
                    fit="cover"
                    class="detail-image"
                  />
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="驳回理由" :span="2" v-if="detailData.rejectText">
                <span style="color: #F56C6C;">{{ detailData.rejectText }}</span>
              </el-descriptions-item>
            </el-descriptions>
          </el-card>

          <!-- 处理详情 -->
          <el-card
            class="detail-section"
            shadow="never"
            v-if="(detailData.handlerName || detailData.handlerPhone) || displayMaterialList.length > 0 || signatureList.length > 0 || getProcessImageList(detailData.repairProcessImgs).length > 0 || supplierInfoList.length > 0 || quoteInfo.num || quoteInfo.remark || auditControlInfo.controlNum || auditControlInfo.controlRemark || getAcceptanceImageList(detailData.repairAfterImgs).length > 0"
          >
            <div slot="header" class="section-title">处理详情</div>

            <!-- 维修人员信息 -->
            <div v-if="detailData.handlerName || detailData.handlerPhone" class="sub-section">
              <div class="sub-section-title">维修人员信息</div>
              <el-descriptions :column="2" border>
                <el-descriptions-item label="维修人员">
                  {{ detailData.handlerName || '-' }}{{ detailData.handlerPhone ? `（${detailData.handlerPhone}）` : '' }}
                </el-descriptions-item>
              </el-descriptions>
            </div>

            <!-- 使用材料信息 -->
            <div v-if="displayMaterialList.length > 0" class="sub-section">
              <div class="sub-section-title">使用材料信息</div>
              <el-table :data="displayMaterialList" border>
                <el-table-column prop="name" label="材料名称" align="center" />
                <el-table-column prop="num" label="数量" align="center" />
                <el-table-column prop="unit" label="单位" align="center" />
                <el-table-column prop="price" label="单价" align="center">
                  <template slot-scope="scope">
                    ¥{{ scope.row.price }}
                  </template>
                </el-table-column>
                <el-table-column label="小计" align="center">
                  <template slot-scope="scope">
                    ¥{{ calculateMaterialTotal(scope.row) }}
                  </template>
                </el-table-column>
              </el-table>
              <div class="material-summary">
                <span class="summary-label">合计：</span>
                <span class="summary-price">¥{{ detailData.repairMaterialFee || '0.00' }}</span>
              </div>
            </div>

            <!-- 维修图片信息 -->
            <div v-if="getProcessImageList(detailData.repairProcessImgs).length > 0" class="sub-section">
              <div class="sub-section-title">维修图片信息</div>
              <div class="image-list">
                <el-image
                  v-for="(img, index) in getProcessImageList(detailData.repairProcessImgs)"
                  :key="index"
                  :src="img"
                  :preview-src-list="getProcessImageList(detailData.repairProcessImgs)"
                  fit="cover"
                  class="detail-image"
                />
              </div>
            </div>

            <!-- 签名信息 -->
            <div v-if="signatureList.length > 0" class="sub-section">
              <div class="sub-section-title">签名信息</div>
              <div
                v-for="(signature, index) in signatureList"
                :key="index"
                class="signature-record-item"
              >
                <div class="signature-role-name">
                  {{ signature.roleName }}签名栏
                </div>
                <div class="signature-image-wrapper">
                  <el-image
                    :src="signature.img"
                    :preview-src-list="[signature.img]"
                    fit="contain"
                    class="signature-image"
                  />
                </div>
              </div>
            </div>
            
            <!-- 供应商信息 -->
            <div v-if="supplierInfoList.length > 0" class="sub-section">
              <div class="sub-section-title">供应商信息</div>
              <el-table :data="supplierInfoList" border class="supplier-info-table">
                <el-table-column prop="name" label="供应商名称" align="center" min-width="160">
                  <template slot-scope="scope">
                    {{ scope.row.name || '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="rsId" label="编号" align="center" min-width="180">
                  <template slot-scope="scope">
                    {{ scope.row.rsId || '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="contactName" label="联系人" align="center" min-width="120">
                  <template slot-scope="scope">
                    {{ scope.row.contactName || '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="tel" label="电话" align="center" min-width="140">
                  <template slot-scope="scope">
                    {{ scope.row.tel || '-' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            
            <!-- 客服报价 -->
            <div v-if="quoteInfo.num || quoteInfo.remark" class="sub-section">
              <div class="sub-section-title">客服报价</div>
              <el-descriptions :column="2" border>
                <el-descriptions-item label="报价金额" v-if="quoteInfo.num">
                  <span class="quote-price">¥{{ quoteInfo.num }}</span>
                </el-descriptions-item>
                <el-descriptions-item label="报价说明" :span="2" v-if="quoteInfo.remark">
                  <div class="remark-content">{{ quoteInfo.remark }}</div>
                </el-descriptions-item>
              </el-descriptions>
            </div>

            <!-- 审计控价信息 -->
            <div v-if="auditControlInfo.controlNum || auditControlInfo.controlRemark" class="sub-section">
              <div class="sub-section-title">审计控价信息</div>
              <el-descriptions :column="2" border>
                <el-descriptions-item label="控价金额" v-if="auditControlInfo.controlNum">
                  <span class="control-price">¥{{ auditControlInfo.controlNum }}</span>
                </el-descriptions-item>
                <el-descriptions-item label="控价说明" :span="2" v-if="auditControlInfo.controlRemark">
                  <div class="remark-content">{{ auditControlInfo.controlRemark }}</div>
                </el-descriptions-item>
              </el-descriptions>
            </div>

            <!-- 验收图片 -->
            <div v-if="getAcceptanceImageList(detailData.repairAfterImgs).length > 0" class="sub-section">
              <div class="sub-section-title">验收图片</div>
              <div class="image-list">
                <el-image
                  v-for="(img, index) in getAcceptanceImageList(detailData.repairAfterImgs)"
                  :key="index"
                  :src="img"
                  :preview-src-list="getAcceptanceImageList(detailData.repairAfterImgs)"
                  fit="cover"
                  class="detail-image"
                />
              </div>
            </div>
          </el-card>

          <!-- 业主评价 -->
          <el-card class="detail-section" shadow="never" v-if="detailData.rateInfo">
            <div slot="header" class="section-title">业主评价</div>
            <div class="rate-content">
              <p class="rate-text">{{ detailData.rateInfo }}</p>
              <div class="image-list" v-if="getRateImageList(detailData.rateImgs).length > 0">
                <el-image
                  v-for="(img, index) in getRateImageList(detailData.rateImgs)"
                  :key="index"
                  :src="img"
                  :preview-src-list="getRateImageList(detailData.rateImgs)"
                  fit="cover"
                  class="detail-image"
                />
              </div>
            </div>
          </el-card>
        </div>

        <div v-if="!detailData && !loading" class="no-data">
          <el-empty description="暂无数据" />
        </div>
      </div>
    </el-card>
    
    <!-- 验收单预览组件 -->
    <preview-acceptance-form
      :visible="showAcceptancePreview"
      :acceptance-detail="detailData"
      @close="showAcceptancePreview = false"
    />
  </div>
</template>

<script>
import { listAcceptanceOrders } from '@/api/work/acceptanceManageApi'

export default {
  name: 'AcceptanceDetailList',
  data() {
    return {
      loading: false,
      detailData: null,
      displayMaterialList: [],
      signatureList: [],
      supplierInfoList: [],
      quoteInfo: {},
      auditControlInfo: {}
    }
  },
  created() {
    this.loadDetail()
  },
  methods: {
    async loadDetail() {
      try {
        this.loading = true
        const acceptanceId = this.$route.query.acceptanceId

        if (!acceptanceId) {
          this.$message.warning('验收单ID不存在')
          return
        }

        const { data } = await listAcceptanceOrders({
          id: acceptanceId,
          page: 1,
          row: 1
        })

        if (data && data.length > 0) {
          this.detailData = data[0]
          this.parseDetailData()
        } else {
          this.$message.warning('未找到验收单信息')
        }
      } catch (error) {
        console.log('加载验收单详情失败', error)
        this.$message.error('加载验收单详情失败')
      } finally {
        this.loading = false
      }
    },
    parseDetailData() {
      if (!this.detailData) return
      
      // 解析材料列表
      this.displayMaterialList = this.parseMaterialList(this.detailData.materialList)
      
      // 解析签名列表
      this.signatureList = this.parseSignatureList(this.detailData.signPics)
      
      // 解析供应商信息
      this.supplierInfoList = this.parseSupplierInfoList(this.detailData.supplierInfo)
      
      // 解析报价信息
      this.quoteInfo = this.parseQuoteInfo(this.detailData.quoteInfo)
      
      // 解析审计控价信息
      this.auditControlInfo = this.parseAuditControl(this.detailData.auditControl)
    },
    parseMaterialList(materialData) {
      if (!materialData) return []
      try {
        if (typeof materialData === 'string') {
          return JSON.parse(materialData)
        }
        if (Array.isArray(materialData)) {
          return materialData
        }
        return []
      } catch (error) {
        console.log('解析材料列表失败:', error)
        return []
      }
    },
    parseSignatureList(signPicsData) {
      if (!signPicsData) return []
      try {
        let dataArray = []
        if (typeof signPicsData === 'string') {
          const cleanedData = signPicsData
            .replace(/,(\s*[}\]])/g, '$1')
            .replace(/,{2,}/g, ',')
            .replace(/\[,/g, '[')
            .replace(/,\]/g, ']')
          signPicsData = JSON.parse(cleanedData)
        }
        if (Array.isArray(signPicsData)) {
          dataArray = signPicsData
        } else if (typeof signPicsData === 'object' && signPicsData !== null) {
          dataArray = [signPicsData]
        }
        const result = []
        for (const item of dataArray) {
          if (typeof item === 'string') {
            try {
              const parsed = JSON.parse(item.replace(/,(\s*[}\]])/g, '$1'))
              if (parsed && typeof parsed === 'object') {
                result.push(parsed)
              }
            } catch (e) {
              console.warn('解析单条签名信息失败:', e)
            }
          } else if (typeof item === 'object' && item !== null) {
            result.push(item)
          }
        }
        return result
      } catch (error) {
        console.log('解析签名列表失败:', error)
        return []
      }
    },
    parseSupplierInfoList(supplierInfoData) {
      if (!supplierInfoData) return []
      try {
        if (typeof supplierInfoData === 'string') {
          supplierInfoData = JSON.parse(supplierInfoData)
        }
        if (Array.isArray(supplierInfoData)) {
          return supplierInfoData
        } else if (typeof supplierInfoData === 'object') {
          return [supplierInfoData]
        }
        return []
      } catch (error) {
        console.log('解析供应商信息失败', error)
        return []
      }
    },
    parseQuoteInfo(quoteInfoData) {
      if (!quoteInfoData) return {}
      try {
        if (typeof quoteInfoData === 'string') {
          return JSON.parse(quoteInfoData)
        }
        return quoteInfoData
      } catch (error) {
        console.log('解析报价信息失败:', error)
        return {}
      }
    },
    parseAuditControl(auditControlData) {
      if (!auditControlData) return {}
      try {
        if (typeof auditControlData === 'string') {
          return JSON.parse(auditControlData)
        }
        return auditControlData
      } catch (error) {
        console.log('解析审计控价信息失败:', error)
        return {}
      }
    },
    getImageList(imgsString) {
      if (!imgsString) return []
      if (typeof imgsString === 'string') {
        return imgsString.split(',').filter(url => url.trim() !== '')
      }
      if (Array.isArray(imgsString)) {
        return imgsString.filter(url => url && url.trim() !== '')
      }
      return []
    },
    getProcessImageList(repairProcessImgs) {
      if (!repairProcessImgs) return []
      try {
        const data = typeof repairProcessImgs === 'string' 
          ? JSON.parse(repairProcessImgs) 
          : repairProcessImgs
        if (data && data.images) {
          if (typeof data.images === 'string') {
            return data.images.split(',').filter(img => img.trim())
          }
          if (Array.isArray(data.images)) {
            return data.images.filter(img => img && img.trim())
          }
        }
        return []
      } catch (err) {
        console.log('解析维修图片失败:', err)
        return []
      }
    },
    getAcceptanceImageList(repairAfterImgs) {
      if (!repairAfterImgs) return []
      try {
        let data
        if (typeof repairAfterImgs === 'string') {
          data = JSON.parse(repairAfterImgs)
        } else {
          data = repairAfterImgs
        }
        if (data && data.images) {
          if (typeof data.images === 'string') {
            return data.images.split(',').filter(img => img.trim())
          }
          if (Array.isArray(data.images)) {
            return data.images.filter(img => img && img.trim())
          }
        }
        return []
      } catch (err) {
        console.log('解析验收图片失败:', err)
        return []
      }
    },
    getRateImageList(rateImgs) {
      if (!rateImgs) return []
      try {
        if (typeof rateImgs === 'string') {
          const parsed = JSON.parse(rateImgs)
          if (parsed && parsed.images) {
            if (typeof parsed.images === 'string') {
              return parsed.images.split(',').filter(img => img.trim())
            }
            if (Array.isArray(parsed.images)) {
              return parsed.images.filter(img => img && img.trim())
            }
          }
        }
        return []
      } catch (err) {
        console.log('解析评价图片失败:', err)
        return []
      }
    },
    getDetailLocationText() {
      if (!this.detailData) return ''
      
      if (this.detailData.orderType === 1 || this.detailData.orderType === '1') {
        return this.detailData.addressDetail || ''
      } else if (this.detailData.orderType === 0 || this.detailData.orderType === '0') {
        const building = this.detailData.floorNum || this.detailData.buildingNum || ''
        const unit = this.detailData.unitNum || ''
        const room = this.detailData.roomNum || this.detailData.roomName || ''
        
        if (building || unit || room) {
          let location = ''
          if (building) location += `${building}栋`
          if (unit) location += `${unit}单元`
          if (room) location += room
          return location || this.detailData.roomName || ''
        }
        
        return this.detailData.roomName || ''
      }
      
      return this.detailData.addressDetail || this.detailData.roomName || ''
    },
    getOrderTypeText(orderType) {
      const typeMap = {
        '0': '室内报修',
        '1': '公区报修'
      }
      return typeMap[String(orderType)] || '-'
    },
    getWarrantyTypeText(warrantyType) {
      const typeMap = {
        '1': '保修期内',
        '2': '保修期外'
      }
      return typeMap[String(warrantyType)] || '-'
    },
    formatStatusName(status) {
      // 验收单状态映射（0-3）
      const acceptanceStatusMap = {
        '0': '待验收',
        '1': '处理中',
        '2': '已完成',
        '3': '已驳回'
      }
      
      // 工单状态映射（1000-1200）
      const repairStatusMap = {
        '1000': '待派单',
        '1001': '待勘察',
        '1002': '待报价',
        '1003': '待维修',
        '1004': '待审核',
        '1005': '待验收',
        '1100': '已完成',
        '1200': '已驳回'
      }
      
      const statusStr = String(status)
      
      // 先尝试验收单状态映
      if (acceptanceStatusMap[statusStr]) {
        return acceptanceStatusMap[statusStr]
      }
      
      // 再尝试工单状态映
      if (repairStatusMap[statusStr]) {
        return repairStatusMap[statusStr]
      }
      
      return '-'
    },
    getStatusTagType(status) {
      const s = String(status)
      
      // 验收单状态标签类型
      if (s === '0') return 'warning'  // 待验收
      if (s === '1') return 'primary'  // 处理中
      if (s === '2') return 'success'  // 已完成
      if (s === '3') return 'danger'   // 已驳回
      
      // 工单状态标签类
      if (s === '1100') return 'success'
      if (s === '1200') return 'danger'
      
      return 'primary'
    },
    calculateMaterialTotal(material) {
      const price = parseFloat(material.price) || 0
      const num = parseFloat(material.num) || 0
      return (price * num).toFixed(2)
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
/* el-descriptions 单元格最小宽?*/
::v-deep .el-descriptions.is-bordered .el-descriptions-item__cell {
  min-width: 100px;
}

.acceptance-detail-container {
  padding: 20px;
}

/* 工单详情样式 */
.repair-detail-content {
  padding: 0;
  /* 覆盖弹窗 body 的居中对齐，整体内容左对?*/
  text-align: left;
}

.detail-section {
  margin-bottom: 20px;
}

.section-title {
  text-align: left;
  /* 保证占满整行，避免被居中 */
  display: inline-block;
  font-weight: 600;
  font-size: 16px;
  color: #333;
  padding-left: 10px;
  border-left: 4px solid #409EFF;
}

/* 覆盖默认卡片头部居中，整体左对齐 */
.detail-section ::v-deep .el-card__header {
  text-align: left;
  justify-content: flex-start;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.detail-image {
  width: 120px;
  height: 120px;
  border-radius: 4px;
  cursor: pointer;
}

.material-summary {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #E8E8E8;
}

.summary-label {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.summary-price {
  font-size: 18px;
  color: #FF6B35;
  font-weight: 600;
}

.quote-price,
.control-price {
  font-size: 18px;
  color: #FF6B35;
  font-weight: 600;
  display: inline-block;
  min-width: 120px;
}

.remark-content {
  padding: 10px;
  background: #F8F9FA;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  line-height: 1.6;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.rate-content {
  padding: 10px 0;
}

.rate-text {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 10px;
  word-break: break-all;
}

.supplier-info-table {
  margin-top: 10px;
}

.signature-record-item {
  display: inline-block;
  vertical-align: top;
  margin: 0 16px 16px 0;
  padding: 10px;
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  width: 300px;
}

.signature-record-item:last-child {
  margin-bottom: 0;
}

.signature-role-name {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  margin-bottom: 10px;
  padding-left: 10px;
  border-left: 4px solid #409EFF;
}

.signature-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  background: #F8F9FA;
}

.signature-image {
  width: 100%;
  height: 100%;
}

.sub-section {
  margin-bottom: 20px;
}

.sub-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.no-data {
  padding: 40px 0;
  text-align: center;
}
</style>

